import { RangeFilter } from 'types/Filter';

export const paramsOutsideAlias = ['page', 'limit', 'offset', 'sort_id'];
export const paramsOutsideFilters = ['name', ...paramsOutsideAlias, 'alias'];
export const secondaryQueryFilters = [
  ...paramsOutsideFilters,
  'product_type',
  'price_from',
  'price_to',
  'gclid',
  'is_available',
];
export const successiveAliasRestFilters = ['name', 'limit', 'sort_id', 'is_available'];
export const intFields = ['is_available'];
export const rangeFields: RangeFilter[] = ['price'];
export const rangeFieldsMultipliers: Record<RangeFilter, number> = {
  price: 100,
};
